import React, { forwardRef } from "react";
import DayPicker from "react-day-picker";
import { getCurrentLocale } from "../../../_utils/dateFnsLocale";

import "./styles.css";

const DatePicker = forwardRef(({ ...props }, ref) => {
  const locale = getCurrentLocale();
  const months = Array.from({ length: 12 }, (x, i) =>
    locale?.localize?.month(i, { width: "wide" })
  );
  const weekdaysLong = Array.from({ length: 7 }, (x, i) =>
    locale?.localize?.day(i, { width: "wide" })
  );
  const weekdaysShort = Array.from({ length: 7 }, (x, i) =>
    locale?.localize?.day(i, { width: "short" })
  );

  return (
    <DayPicker
      ref={ref}
      locale={locale?.code}
      months={months}
      firstDayOfWeek={locale?.options?.weekStartsOn}
      weekdaysLong={weekdaysLong}
      weekdaysShort={weekdaysShort}
      showOutsideDays
      {...props}
    />
  );
});

DatePicker.defaultProps = {};

DatePicker.propTypes = {};

export default DatePicker;
